import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import PostControls from 'flarum/forum/utils/PostControls';
import PostComponent from 'flarum/forum/components/Post';
app.initializers.add('flarum-akismet', () => {
  extend(PostControls, 'destructiveControls', function (items, post) {
    if (items.has('approve')) {
      const flags = post.flags();
      if (flags && flags.some(flag => flag?.type() === 'akismet')) {
        const approveItem = items.get('approve');
        if (approveItem && typeof approveItem === 'object' && 'children' in approveItem) {
          approveItem.children = app.translator.trans('flarum-akismet.forum.post.not_spam_button');
        }
      }
    }
  });
  override(PostComponent.prototype, 'flagReason', function (original, flag) {
    if (flag.type() === 'akismet') {
      return app.translator.trans('flarum-akismet.forum.post.akismet_flagged_text');
    }
    return original(flag);
  });
});